import type { JobStatus } from "../types/routecore";

// Estilos de badge por estado de job. Cores se alinham com o tipo de
// sinal:
//
//   - cinza: estado neutro/transiente (queued, processing).
//   - verde: estado terminal feliz (solved).
//   - amarelo: terminal mas com avisos (partial).
//   - vermelho: terminal com erro (failed, timeout, infeasible).
//   - ink-fade: cancelado.
export function statusBadgeClass(status: JobStatus | string | undefined): string {
  switch (status) {
    case "solved":
      return "bg-brand-100 text-brand-800";
    case "partial":
      return "bg-amber-100 text-amber-800";
    case "queued":
    case "processing":
      return "bg-sky-100 text-sky-800";
    case "infeasible":
    case "failed":
    case "timeout":
      return "bg-rose-100 text-rose-800";
    case "cancelled":
      return "bg-ink-200 text-ink-700";
    default:
      return "bg-ink-100 text-ink-700";
  }
}

export const terminalStatuses: ReadonlySet<JobStatus> = new Set([
  "solved",
  "partial",
  "infeasible",
  "failed",
  "timeout",
  "cancelled",
]);

export function isTerminal(s: string | undefined): boolean {
  return !!s && terminalStatuses.has(s as JobStatus);
}
